import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  selector: 'app-loading-spinner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loading-spinner.component.html',
  styleUrl: './loading-spinner.component.scss',
})
export class LoadingSpinnerComponent {
  readonly strokeWidth = input<number | undefined>(10);
  readonly size = input<number>(64);

  readonly variant = input<'blue' | 'white' | 'grey'>('blue');
}
